var map = {
	"./pic-logo-CourseCentre.png": "35de",
	"./pic-logo-bl.png": "7ba1",
	"./pic-logo-ipstar.png": "5547",
	"./pic-logo-jd.png": "5d4c",
	"./pic-logo-lj.png": "a27d",
	"./pic-logo-ol.png": "c79d",
	"./pic-logo-selz.png": "9244",
	"./pic-logo-sgj.png": "008b",
	"./pic-logo-wq.png": "2f13",
	"./pic-logo-xtia.png": "f056",
	"./pic-logo-ys.png": "ecc3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "58e3";